<template>
  <div>
    <div class="topsearch section">
      <div class="toptitle ">
        {{condition}} <span style="margin:0 5px" >-</span> {{condition2}}
        <span class="tip">为您找到相关结果 <strong>{{total}}</strong> 个</span>
      </div>
      <div class="topright">
        <div class="search">
          <el-input class="inp" clearable v-model="keywords" placeholder="请输入关键词" type="text" />
          <button class="but" @click="search">搜索</button>
        </div>
      </div>
    </div>
    <div class="library">
      <div class="book-rack" v-show="list.length>0">
        <ul>
          <li v-for="(elem,i) of list" :key="i" @click="perioDEtails(elem.periodicalId)">
            <img :src="require('../../assets/photo/'+elem.periodicalId+'.png')" alt="无图" />
            <div class="book-tit">{{elem.periodicalName}}</div>
          </li>
        </ul>
      </div>
      <div style="clear:both"></div>
    <sorry v-show="list.length==0"></sorry>  
      <el-pagination
           class="page"
            :background="true"
            layout="prev, pager, next"
            :current-page="pageNo"
            :page-size="pageSize"
            :total="total"
            @current-change="page"
          ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props:['pageNo','pageSize','total','list','condition','condition2'],
  components:{
    sorry:resolve=>require(['../notfound'],resolve)
  },
  created(){
    this.keywords=this.$route.query.main
  },
  data(){return{
    keywords:''
  }},
  methods:{
    search(){
      let query={...this.$route.query,main:this.keywords}
      this.$router.push({
        path:'',
        query
      })
    },
     page(current) {
      //动态滚动条
      var n = 0;
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var timer1 = setInterval(() => {
        n++;
        window.scrollBy(100, -scrollTop / 20);
        if (n == 20) {
          clearInterval(timer1);
        }
      }, 20);
      this.$emit("PN", current);
    },
    //期刊查询
    perioDEtails(x){
      var newPage=this.$router.resolve({
        path:'/perioDetails',
        query:{
          periodicalId:x
        }
      })
      window.open(newPage.href,'_blank')
    }
  },
};
</script>

<style scoped>
.section{
  position: relative;
}
.section::before{
    content: "";
    display: block;
    width: 30px;
    height: 1px;
    background-color: #02354b;
    position: absolute;
    left: 0;
    bottom: -1px;
    z-index: 9;
}
.section::after{
 content: "";
 display: block;
    width: 100%;
    height: 1px;
    background-color: #ddd;
    position: absolute;
    left: 0;
    bottom: -1px;
}
.topsearch {
  display: -webkit-box;
  display: -ms-flexbox;
  height: 50px;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
      padding-top: 50px;
    padding-bottom: 40px;
    margin-bottom: 18px;

}
.topsearch>.toptitle{
  height: 50px;
    font-weight: 550;
    font-size: 24px;
}
.topsearch>.toptitle>.tip{
  color: rgb(97, 95, 108);
  font-weight: normal;
  font-size: 16px;
  margin-left: 20px;
}
.topright > .search {
  background: url('../../assets/img/s_res_searchbox_input_bg.png') no-repeat 20px 16px;
  box-sizing: border-box;
  display: inline-block;
  width: 400px;
  height: 48px;
  border: 1px solid #ddd;
  padding-left: 38px;
  border-radius: 3px;
  background-color: #fff;
  white-space: nowrap;
  overflow: hidden;
}
.search>.inp>::v-deep input,.search>::v-deep .inp {
  width: 280px;
  vertical-align: top;
  height: 48px;
  appearance: none;
  border: none;
  background: transparent;
  /* margin-top: -2px; */
}
.search > .but {
    transition: .3s;
    width: 80px;
    height: 48px;
    background-color: #02354b;
    border: 0;
    text-align: center;
    font-size: 14px;
    color: #fff;
    cursor: pointer;
    padding: 12px 0;
    border-radius: 0;
}
.search > .but:hover{
   background: #fea724;
    color: #fff;
}
.library {
  /* display: inline-block; */
  width: 1200px;
}
.library > .search-count {
  margin-left: 40px;
  margin-bottom: 20px;
  color: #888;
  font-size: 14px;
  line-height: 24px;
}
.book-rack {
 
}
.book-rack > ul {
  list-style: none;
  padding: 0;
}
.book-rack > ul > li {
     width: 150px;
    margin: 50px 26px 0 20px;
    position: relative;
    text-align: center;
    float: left;
  position: relative;
}
.book-rack > ul > li > img {
  top: 0;
  position: relative;
  z-index: 2;
  display: inline-block;
  border: 1px solid #ddd;
  width: 150px;
  height: 201px;
  transition: 0.5s;
  cursor: pointer;
}
.book-rack > ul > li > img:hover {
  top: -10px;
}
.book-rack > ul > li > .book-tit {
  cursor: pointer;
  position: relative;
  z-index: 1;
  margin-top: 23px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  font-size: 15px;
  color: #016072;
  width: 160px;
  overflow: hidden;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.book-rack > ul > li:hover .book-tit {
  color: #52b8cc;
}
.book-rack ul li:nth-child(6n + 1)::after {
      width: 1200px;
    height: 20px;
    background-color: #fff;
    -webkit-box-shadow: 0 5px 30px 0 rgba(84,94,96,.14);
    box-shadow: 0 5px 30px 0 rgba(84,94,96,.14);
    content: "";
    position: absolute;
    left: -40px;
    top: 200px;
    z-index: 0;
}
.page{
  text-align: center;
  margin: 30px 0 50px 0;

}
</style>
<style>
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #02354b;
    color: #FFF;
  }
</style>